import ArticleCompo from 'csdd_components/ArticleCompo';
import Footer from 'csdd_components/Footer';
import HomeNavBar from 'csdd_components/HomeNavBar';
import Newsletter from 'csdd_components/Newsletter';
import TopNavBar from 'csdd_components/TopNavBar';
import data from 'csdd_data/newsAndInsights';
import { useParams } from 'react-router-dom';
import slug from 'slug';

const Article = () => {
  const { newsSlug } = useParams();
  const article = data.find((item) => {
    return newsSlug === slug(item.title);
  });

  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <ArticleCompo article={article} />
      <Newsletter />
      <Footer />
    </>
  );
};
export default Article;
